import React from 'react';
import PropTypes from 'prop-types';

import { Box, Grid } from '@material-ui/core';

const HeaderSection = ({ children, alignItems, ...props }) => {
  return (
    <Grid item {...props}>
      {alignItems ? (
        <Box display="flex" alignItems={alignItems}>
          {children}
        </Box>
      ) : (
        children
      )}
    </Grid>
  );
};

HeaderSection.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  // TODO: make it known that all "Grid" propTypes are available here
};

HeaderSection.defaultProps = {};

export default HeaderSection;
